<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Transaction Audit</div>
        <div>
          <bread-crumb :bread-crumbs="['Transaction Audit']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-card-text>
        <v-row class="mt-1">
          <v-col cols="12" md="2" lg="2" xs="12">
            <v-text-field
              type="date"
              dense
              outlined
              placeholder="From"
              v-model="from_date"
              :max="maxDate"
              :rules="[validateFromDate]"
              :items="transactionAudit"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2" lg="2" xs="12">
            <v-text-field
              type="date"
              dense
              outlined
              placeholder="To"
              v-model="to_date"
              :items="transactionAudit"
              :rules="[validateToDate]"
              :max="maxDate"
            ></v-text-field>
          </v-col>
          <div class="d-flex">
            <v-btn depressed 
              small
              class="text-capitalize"
              @click="getTransactionAudit()"
              color="primary"
              >Get Results</v-btn
            >
          </div>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table fixed-header  height="55vh"
          dense
          :headers="headers"
          :items-per-page="10"
          :items="transactionAudit"
          loading-text="Please select the criteria to view records."
          no-data-text="Please select the criteria to view records."
          class="mt-4 p-1"
        >
        </v-data-table>
        <OverlayPageVue :showOverlay="loaderOverlay" />
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import userService from "@/services/UserService/userService.js";
export default {
  name: "Transaction Audit",
  data: () => ({
    search: "",
    from_date: null,
    to_date: null,
    loaderOverlay: false,
    transactionAudit: [],
    headers: [
      {
        text: "View Type",

        sortable: false,
        value: "view_type",
      },
      { text: "Tran Id", value: "transaction_id" },
      { text: "Pin No", value: "pin_no", sortable: false },
      { text: "Branch Name", value: "branch_name" },

      { text: "User", value: "user" },
      { text: "Date", value: "date" },
    ],
  }),

  components: {
    BreadCrumb,
    OverlayPageVue,
  },

  watch: {},
  computed: {
    maxDate() {
      // get current date and format as YYYY-MM-DD for use with max attribute
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      return `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
    },
  },
  //   created () {
  //     this.initialize()
  //   },
  mounted() {},
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    validateFromDate(value) {
      if (value && this.to_date) {
        return (
          value <= this.to_date || "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.from_date) {
        return (
          value >= this.from_date || "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    async getTransactionAudit() {
      this.loaderOverlay = true;
      try {
        const params = {
          from_date: this.from_date,
          to_date: this.to_date,
          skip: 0,
          limit: 50,
        };
        const response = await userService.getTranscationAduitlog(params);
        console.log(response);
        if (response.status === 200) {
          this.transactionAudit = response.data;
          console.log("transactionAudit", this.transactionAudit);
          this.stoploader();
        } 
        // else if (response.status === 401) {
        //   this.transactionAudit = [];
        //   this.returnNewToken();
        //   this.getTransactionAudit();
        //   this.stoploader();
        // } 
        else {
          this.transactionAudit == [];
          this.stoploader();
        }
      } catch (error) {
        this.transactionAudit = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
label {
  font-size: 17px;
  color: black;
}
</style>
